import { ModelHelper } from '../classes/model-helper';

export class Offering {
	uid: string;
	name: string;
	displayName: string;

	/**
	 *
	 *
	 * Static mapping function
	 *
	 *
	 *
	 * @param data
	 * @param item
	 * @returns Offering
	 */
	static map(data: any, item: Offering = new Offering()): Offering {
		return item.map(data);
	}

	/**
	 *
	 *
	 * Non static mapping function
	 *
	 *
	 *
	 * @param data
	 * @return Offering
	 */
	public map(data: any): Offering {
		ModelHelper.map(data, this, 'uid');
		ModelHelper.map(data, this, 'name');
		ModelHelper.map(data, this, 'displayName');

		// When display name is missing
		if (data['name'] && !this.displayName) {
			ModelHelper.map(data, this, 'displayName', null, 'name');
		}

		return this;
	}
}
